import { useTranslation } from 'react-i18next';
import { SCard, SEmail, SOuter, STenantName, STitle } from './MultiOrgActiveBanner.styles';

export type MultiOrgActiveBannerProps = {
  tenantName: string;
  email: string;
};

/** Ported from cosafe-app MultiOrgActiveBanner. Sidebar-only. */
export function MultiOrgActiveBanner({ tenantName, email }: MultiOrgActiveBannerProps) {
  const { t } = useTranslation();

  return (
    <SOuter>
      <SCard role="status" aria-live="polite">
        <STitle>{t('tenant_session_active_title')}</STitle>
        <STenantName>{tenantName}</STenantName>
        <SEmail>{email}</SEmail>
      </SCard>
    </SOuter>
  );
}
